import { DMSIDS } from "models";

type DmsInfo = { name: string; group: string | null };

const DMS_BY_ID: Record<DMSIDS, DmsInfo> = {
  [DMSIDS.UNKNOWN]: { name: "Unknown", group: null },
  [DMSIDS.NTCAR]: { name: "NTCar", group: null },
  [DMSIDS.EVA]: { name: "EVA", group: null },
  [DMSIDS.WINCAR]: { name: "WinCar", group: null },
  [DMSIDS.ANON_EVA]: { name: "Anonymous EVA", group: null },
  [DMSIDS.AUTOLINE]: { name: "Autoline", group: null },
  [DMSIDS.AUTOLINE_EF_NEFKENS]: { name: "Autoline EF Nefkens", group: null },
  [DMSIDS.TEST_API]: { name: "Test API", group: "Test API" },
  [DMSIDS.TEST_SOW]: { name: "Test SOW", group: null },
  [DMSIDS.INCADEA]: { name: "Incadea", group: null },
  [DMSIDS.TRUCK_VISION]: { name: "TruckVision", group: null },
  [DMSIDS.ICAR_WO]: { name: "ICar WO", group: null },
  [DMSIDS.CARIT]: { name: "CarIT", group: null },
  [DMSIDS.AUTOLINE_OPEL_MENU]: { name: "Autoline Opel Menu", group: null },
  [DMSIDS.KEYLOOP_MENUS]: { name: "Keyloop Menus", group: "Keyloop" },
  [DMSIDS.CUSTOM_QUERIES]: { name: "Custom Queries", group: null },
  [DMSIDS.KEYLOOP_JOBS]: { name: "Keyloop Jobs", group: "Keyloop" },
  [DMSIDS.EVA_BE_WO]: { name: "EVA Be WO", group: null },
  [DMSIDS.ICAR_PLANNING]: { name: "ICar Planning", group: null },
  [DMSIDS.AUTOFLEX]: { name: "Autoflex", group: "Autoflex" },
  [DMSIDS.AUTOFLEX_QA_STAGING]: { name: "Autoflex QA Staging", group: "Autoflex" },
  [DMSIDS.NEXTLANE]: { name: "Nextlane", group: "Nextlane" },
  [DMSIDS.WINCAR_V1_WB]: { name: "WinCar V1 WB", group: "WinCar" },
  [DMSIDS.EVA_BE]: { name: "EVA Belgium", group: null },
  [DMSIDS.EVA_FR]: { name: "EVA French", group: null },
  [DMSIDS.INCADEA_API]: { name: "Incadea API", group: "Incadea" },
  [DMSIDS.WINCAR_V2_WB]: { name: "WinCar V2 WB", group: "WinCar" },
  [DMSIDS.WINCAR_API_EVENTS]: { name: "WinCar API Events", group: "WinCar" },
  [DMSIDS.WINCAR_API_V2_EVENTS]: { name: "WinCar API V2 Events", group: "WinCar" },
  [DMSIDS.KEYLOOP_MENUS_STAGING]: { name: "Keyloop Menus Staging", group: "Keyloop" },
  [DMSIDS.KEYLOOP_JOBS_STAGING]: { name: "Keyloop Jobs Staging", group: "Keyloop" },
  [DMSIDS.CARIT_HYBRID]: { name: "CarIT Hybrid", group: null },
  [DMSIDS.INCADEA_HYBRID]: { name: "Incadea Hybrid", group: null },
  [DMSIDS.VINACLES]: { name: "Vinacles", group: "Vinacles" },
  [DMSIDS.TURBO_SAP]: { name: "Turbo SAP", group: null },
  [DMSIDS.GRAND_PRIX_PUBLIC_API]: { name: "Grand Prix Public API", group: null },
  [DMSIDS.CARSYS_PUBLIC_API]: { name: "Carsys Public API", group: null }
};

const DMS_IDS: DMSIDS[] = Object.values(DMSIDS).filter(dmsId => typeof dmsId === "number");

export const DMS_OPTIONS = DMS_IDS.flatMap(dmsId => [{ key: dmsId, value: dmsId, text: DMS_BY_ID[dmsId].name }]);
export const getDmsName = (dmsId: DMSIDS) => (dmsId in DMS_BY_ID ? DMS_BY_ID[dmsId].name : "Unknown");
export const getDmsGroupLabel = (dmsId?: DMSIDS) => (dmsId && dmsId in DMS_BY_ID ? DMS_BY_ID[dmsId].group : null);
